import UserList from './UserList';
import UserShow from './UserShow';
import UserEdit from './UserEdit';

export default {
    list: UserList,
    edit: UserEdit,
    show: UserShow
};